import { Text } from "@bpba/ui-components";
import { BP_CONTAINER_PAD_X, BP_CONTAINER_PAD_Y } from "../../constants/data";

type TituloProps = {
  children: string | undefined;
  isStatic: boolean;
};

export const Titulo = (props: TituloProps) => {
  return (
    <Text
      fontSize={["24px"]}
      lineHeight={"28px !important"}
      fontWeight={"500"}
      paddingX={[16, 59, null, null, props.isStatic ? 0 : 63]}
      paddingBottom={["32px"]}
    >
      {props.children}
    </Text>
  );
};
